/** @jsxImportSource @emotion/react */

import { Typography } from "../Typography";
import { Flex } from "../utilities";
import { Radio } from "./Radio";
import { radioLabelCSS } from "./Radio.css";
import type { RadioLabelProps } from "./Radio.types";

export const RadioLabel = ({
  children,
  iconPosition = "left",
  text,
  label,
  ...restProps
}: RadioLabelProps) => {
  const deprecatedLabel = label || text;

  return (
    <Flex
      as="label"
      alignItems="center"
      native={{
        "data-radio-icon_position": iconPosition,
      }}
      flexDirection={iconPosition === "right" ? "row-reverse" : "row"}
      justifyContent={iconPosition === "right" ? "space-between" : "flex-start"}
      width={iconPosition === "right" ? "100%" : "fit-content"}
      css={radioLabelCSS}
    >
      {children || <Radio {...restProps} />}

      {deprecatedLabel && (
        <Typography variant="label-medium" native={{ "data-radio-label": true }}>
          {deprecatedLabel}
        </Typography>
      )}
    </Flex>
  );
};
